import React from 'react';
import {Dimensions} from 'react-native';
import {get} from 'lodash';

import {asClassComponent} from '/util/hoc.util';

import {ThemeContext} from './ThemeProvider';

export default (Component: any) =>
  asClassComponent((props: any) => (
    <ThemeContext.Consumer>
      {themeProps => (
        <Component
          {...props}
          theme={themeProps} // Deprecated: Use `getTheme` instead.
          getTheme={(...args: any[]) => get(themeProps, ...args)}
          screenWidth={Dimensions.get('window').width}
        />
      )}
    </ThemeContext.Consumer>
  ));
